import { render } from "./LeaguePage.vue?vue&type=template&id=22c4746f"
import script from "./LeaguePage.vue?vue&type=script&lang=js"
export * from "./LeaguePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__